import api from "../api.service"
import { clearDemoTour, leaveDemoTour, setDemoTour } from "./demoTourFlag"

/**
 * GET /demo-tour - whether this person may start the tour, and theirs if they have one.
 * Always answered as the signed-in person themselves, on the tour or not.
 *
 * @return {Promise<{eligible: Boolean, tour: {startedAt: String, expiresAt: String, active: Boolean}|null}>}
 */
export function getDemoTourStatus() {
    return api.get("/demo-tour").then((res) => res.data)
}

/**
 * Starts the tour (or picks up the one running), then reloads into it. The cookie the
 * API sets rides on file links and images, which cannot send the header.
 */
export function startDemoTour() {
    return api.post("/demo-tour/start", {}, { withCredentials: true }).then((res) => {
        const tour = res.data?.tour

        if (!tour?.active) {
            throw new Error("The demo tour has ended.")
        }

        setDemoTour(tour)
        window.location.assign("/")
    })
}

/**
 * "Done with demo" on the Home tile: ends the person's tour for good (or, never started,
 * makes sure it is never offered again).
 *
 * @return {Promise<{tour: Object}>}
 */
export function endDemoTour() {
    return api.post("/demo-tour/end", {}, { withCredentials: true }).then((res) => {
        clearDemoTour()
        return res.data
    })
}

/** Back to the person's own missionX. The tour keeps running: they can come back to it. */
export function exitDemoTour() {
    return api
        .post("/demo-tour/exit", {}, { withCredentials: true })
        .catch(() => {})
        .then(() => {
            clearDemoTour()
            leaveDemoTour()
        })
}
